module.exports = __webpack_public_path__ + "static/media/close.a49513c1.svg";